import * as TypeGraphQL from "type-graphql";
export var SignalOutcomeType;
(function (SignalOutcomeType) {
    SignalOutcomeType["SUCCESS"] = "SUCCESS";
    SignalOutcomeType["FAILURE"] = "FAILURE";
    SignalOutcomeType["NEUTRAL"] = "NEUTRAL";
    SignalOutcomeType["PENDING"] = "PENDING";
})(SignalOutcomeType || (SignalOutcomeType = {}));
TypeGraphQL.registerEnumType(SignalOutcomeType, {
    name: "SignalOutcomeType",
    description: undefined,
});
//# sourceMappingURL=SignalOutcomeType.js.map